import { FC } from 'react';

import PaymentLinkLayout from 'payment-link/components/layouts/payment-link-layout';

import RoutesWithNotFound from 'common/config/routes/routesWithNotFound.util';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const PaymentLinkRouting: FC<Props> = ({ children }) => {
  return (
    <PaymentLinkLayout>
      <RoutesWithNotFound>{children}</RoutesWithNotFound>
    </PaymentLinkLayout>
  );
};
export default PaymentLinkRouting;
